import type {CSSProperties} from 'react';
import type {TextSize} from '@Components/text';

export interface PlanLockedUpgradePillTooltip {
  id: string;
  tooltipClasses?: string;
  style?: CSSProperties;
}

export interface PlanLockedUpgradePillProps {
  onClick?: () => void;
  tooltip?: PlanLockedUpgradePillTooltip;
  textSize?: TextSize;
  blockClasses?: string;
}

export const PLAN_LOCKED_UPGRADE_PILL_TOOLTIP_DELAY = {show: 50, hide: 100};
